<template>
    <headboard></headboard>
    <div class="" style="padding-left:5%;padding-right:5%;">
        <div class="row mt-5">
        <div class="col-sm-12">
            <h2>Welcome to Modspec’s Compliance Assessment Scoping Tool</h2>
            <p>Access pricing quickly with our scoping tool for all NCC2019 NCC2022 Section J assessments. <br>
              Fill in the required fields and download a quote in seconds. <br>
              For inquiries, email us at <a href="mailto:commercial@modspec.com.au">commercial@modspec.com.au</a></p>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-sm-12">
            <router-link class="btn btn-primary" to="/scopingtool">Generate Quote</router-link>
        </div>
    </div>
    </div>
    
</template>
<script>
import header from "../components/header.vue"
export default {
  name: 'scoping-page',
  data: function () {
    return {
    }
  },
  components: {
    'headboard':header
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style></style>